var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100vw","overflow":"hidden"},attrs:{"id":"home-container"}},[_c('a',{attrs:{"href":_vm.notice}},[_vm._v(_vm._s(_vm.notice))])])}
var staticRenderFns = []

export { render, staticRenderFns }